import { render, staticRenderFns } from "./TextIconTile.vue?vue&type=template&id=9d70e1b2&scoped=true&"
import script from "./TextIconTile.vue?vue&type=script&lang=js&"
export * from "./TextIconTile.vue?vue&type=script&lang=js&"
import style0 from "./TextIconTile.vue?vue&type=style&index=0&id=9d70e1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d70e1b2",
  null
  
)

export default component.exports